export enum ServicesEnum {
  CaregivingWithUgosCar = 'CAREGIVING_WITH_UGOS_CAR',
  CaregivingWithUsersCar = 'CAREGIVING_WITH_USERS_CAR',
  CaregivingWithoutCar = 'CAREGIVING_WITHOUT_CAR',
  CaregivingViaTelemedicine = 'CAREGIVING_VIA_TELEMEDICINE',
  Errands = 'ERRANDS',
  PhoneAssistance = 'PHONE_ASSISTANCE',
}
